import { STRINGS } from '@/constants/strings';
import type { MutatePlayerOption } from './types';

export const STATE_OPTIONS: MutatePlayerOption[] = [
  { value: '', label: '' },
  ...[
    'GU',
    'MO',
    'PA',
    'AL',
    'HI',
    'MS',
    'PR',
    'AK',
    'IA',
    'MT',
    'RI',
    'ID',
    'NC',
    'SC',
    'AZ',
    'IL',
    'ND',
    'SD',
    'AR',
    'IN',
    'NE',
    'TN',
    'CA',
    'KS',
    'NH',
    'TX',
    'CO',
    'KY',
    'NJ',
    'UT',
    'CT',
    'LA',
    'NM',
    'VA',
    'DC',
    'MA',
    'NV',
    'VI',
    'DE',
    'MD',
    'NY',
    'VT',
    'FL',
    'ME',
    'OH',
    'WA',
    'GA',
    'MI',
    'OK',
    'WI',
    'MN',
    'OR',
    'WV',
    'WY',
  ]
    .sort((a, b) => a.localeCompare(b))
    .map(value => ({ value, label: value })),
];

export const GENDER_OPTIONS: MutatePlayerOption[] = [
  { value: 'Male', label: STRINGS.player.mutatePlayer.profile.genderMale },
  { value: 'Female', label: STRINGS.player.mutatePlayer.profile.genderFemale },
];

export const LEVEL_OPTIONS: MutatePlayerOption[] = Array.from({ length: 10 }, (_, idx) => ({
  value: `level_${idx + 1}`,
  label: STRINGS.player.mutatePlayer.profile.levelLabel(idx + 1),
}));
